import Banner from "./Bannner"
import { useState,useRef,useEffect } from "react";
import HtmlRenderer from "./HtmlRenderer";
import ContactFooter from "./ContactFooter";
import glv from '../utils/getLocalizedValue';
import supabase from '../utils/supabaseClient';

function Openings() {
    const [careers, setCareers] = useState([]);
  
    useEffect(() => {
      getCareers();
    }, []);

    async function getCareers() {
      if (!supabase) return;

      const { data, error } = await supabase
        .from("career")
        .select("*")
        .order("date", { ascending: false }); 
        
  
      if (error) {
        // console.error("Error fetching careers:", error);
      } else {
        setCareers(data);
      }
    }

  // date를 Due: YYYY/MM(ENG)/DD 형식으로 변환
  // 함수 아니고 변수
  // 예시 Due: 2025/JAN/16
  const dueDateString = (date) => {
    if (!date) return "ㅤ";
    const options = { year: 'numeric', month: 'short', day: '2-digit' };
    const formattedDate = new Date(date).toLocaleDateString('en-US', options);
    const [month, day, year] = formattedDate.replace(',', '').split(' ');
    return `Due: ${year}/${month.toUpperCase()}/${day}`;
  }

  return (
    <>
      {
        careers.map((career) => (
          glv(
            <OpeningContainer
              key={career.id}
              domain={career.domain}
              jobtitle={career.title}
              date={dueDateString(career.date) ?? "ㅤ"}
              content={<HtmlRenderer htmlString={career.html} className="prose tracking-[-0.015em]"/>}
            />,
            <OpeningContainer
              key={career.id}
              domain={career.domain}
              jobtitle={career.title_korean}
              date={dueDateString(career.date) ?? "ㅤ"}
              content={<HtmlRenderer htmlString={career.html_korean} className="prose tracking-[-0.015em]" />}
            />
          )
        ))
      }
    </>
  );
}

function OpeningContainer({ domain, jobtitle, content, date }) {
  let contentRef = useRef(null);
  let [isOpen, setIsOpen] = useState(false);
  return (
    <>
      <article className="sm:max-w-[70rem] w-full px-5 font-pretendard">
        <div className="shadow-lg w-full p-3 sm:p-10 items-center bg-brand-silicon-white mt-10">
          <div className="flex w-full h-[8rem] items-center justify-center">
            <div
              className={
                isOpen
                  ? "hidden"
                  : "mobile-hide flex sm:me-10 me-5 h-full items-center font-[400] sm:text-3xl text-2xl sm:pe-10 pe-5 sm:w-[15rem] w-[10rem] justify-center border-r-[1px] border-black"
              }
            >
              {domain && domain}
            </div>
            <div className="flex flex-col w-full h-full justify-end">
              <div className={!isOpen ? "hidden" : "sm:text-3xl text-2xl mb-5"}>
                {domain && domain}
              </div>
              <div className="sm:text-3xl text-3xl font-[900]">
                {jobtitle && jobtitle}
              </div>
              <div
                className={
                  !isOpen ? "sm:text-base text-sm font-[700] mt-5" : "hidden"
                }
              >
                {date && date}
              </div>
            </div>
            <div className="flex w-[3rem]">
              <button
                onClick={() => {
                  setIsOpen(!isOpen);
                }}
                className={`flex transition-transform duration-500 transform 
                  ${isOpen ? "scale-y-[-1]" : ""}`}
              >
                <img
                  src={require("../assets/icon/expand.png")}
                  alt=""
                  className="w-[3rem] object-contain"
                />
              </button>
            </div>
          </div>
          <div
            ref={contentRef}
            style={{
              maxHeight: isOpen
                ? `${contentRef.current?.scrollHeight}px`
                : "0px",
            }}
            className={`transition-[max-height] duration-500 ease-in-out overflow-hidden sm:text-xl text-sm leading-8 ${
              isOpen? "mt-10" : ""
            }`}
          >
            {content && content}
          </div>
        </div>
      </article>
    </>
  );
}

function Intro() {
  const content = glv("At KoolMicro, we’re redefining the future of semiconductor innovation with groundbreaking thermal management solutions. Join a team of passionate experts who thrive on solving complex challenges, pushing the boundaries of technology, and making a global impact. Whether you’re an experienced professional or just starting your career, KoolMicro offers a dynamic environment where your ideas and talents will drive cutting-edge advancements in the semiconductor thermal management industry.<br/><br/>For any questions or application, feel free to reach out to us with the form below, or message us through LinkedIn!"
  ,"KoolMicro는 혁신적인 열 관리 솔루션을 통해 반도체 기술의 미래를 새롭게 정의하고 있습니다. <br/><br/>KoolMicro에 합류하여 기술의 미래를 이끄는데 함께하세요. <br/>저희는 문제를 해결하고 기술의 한계를 넘어 글로벌한 변화를 만들기 위해 열정을 쏟는 전문가들로 이뤄져 있습니다. <br/>풍부한 경력의 전문가든, 이제 막 커리어를 시작하는 신입이든, 당신의 아이디어와 재능이 반도체 열 관리 기술의 최첨단 발전을 이끌수있도록 최적의 환경을 제공합니다.<br/><br/>문의사항이나 지원은 언제든지 페이지 아래 양식 또는 LinkedIn을 통해 메시지를 보내주세요!<br/>")
  return <>
    <div className="max-w-[70rem] font-pretendard f-20 font-[300] tracking-[-0.015em] mt-[3rem] mb-[4rem] text-justify ms-auto me-auto px-5">
      <HtmlRenderer htmlString={content} />
    </div>
  </>
}

function CareerPage() {
    return (
      <>
        <div className="w-full flex-grow overflow-y-scroll overflow-x-hidden">
          <Banner
            title={glv("Open Positions & Job Offers","채용 공고 및 지원")}
            src={require("../assets/banner/career-banner.jpg")}
          />
          <main className="flex flex-col items-center justify-center pt-[5rem] pb-[10rem] first:pt-0 last:pb-0">
            <Intro />
            <Openings />
          </main>
          <ContactFooter />
        </div>
      </>
    );
}

export default CareerPage;
